import { AppProvider } from './context/AppContext.jsx';
import AppShell from './components/shell/AppShell.jsx';
import NewsScreen from './components/news/NewsScreen.jsx';
import ResultsScreen from './components/results/ResultsScreen.jsx';
import OracleScreen from './components/oracle/OracleScreen.jsx';

/**
 * App — root component.
 *
 * Two responsibilities, intentionally separated from the shell:
 *
 *   1. Wrap the tree in the AppProvider so all descendants have access to
 *      navigation state and cross-screen actions.
 *
 *   2. Declare the routing table — a flat map from tab id to screen
 *      instance. Keeping it here (rather than inside AppShell) means the
 *      shell can be tested with stub screens and the screens can be
 *      lazy-loaded if bundle size ever becomes a concern.
 *
 * The routing pattern intentionally avoids `react-router` — for a 3-tab
 * mobile shell with no deep links yet, state-based routing is leaner and
 * the transition behaviour is easier to control. If/when deep links land
 * (push notifications, share sheets), revisit with router migration.
 */
const SCREENS = {
  news: <NewsScreen />,
  results: <ResultsScreen />,
  oracle: <OracleScreen />,
};

export default function App() {
  return (
    <AppProvider>
      <AppShell screens={SCREENS} />
    </AppProvider>
  );
}
